import RunTutorialCustomVideo from './components/lms/RunTutorialCustomVideo';
import {PublicAccordion} from './editor/components/accordionSection/core/publicAccordion.js';
import {SortingActivityClass} from "./editor/components/sortingActivitySection/core/SortingActivityClass";
import {PublicTabs} from "./editor/components/tabsSection/core/publicTabs";
import {flashcardFlip} from "./editor/components/flashcardSection/core/flashcardFlip";
import MatchingRun from "./editor/components/matchingSection/core/MatchingRun";
import AnimationOnScroll from "./components/common/AnimationOnScroll";
import { CustomCourseDescription } from "./components/lms/CustomCourseDescription";
import SidebarDescriptionEditor from './components/lms/SidebarDescriptionEditor';
import EditorQuizzesChecking from "./editor/core/EditorQuizzesChecking";
import {VideoSectionEvents} from "./editor/components/videoSection/core/videoSectionEvents.js";
import TableAccordion from './components/common/TableAccordion';

document.addEventListener("DOMContentLoaded", function () {
    new PublicAccordion().run();
    new SortingActivityClass().run();
    new PublicTabs().run();
    new MatchingRun();

    new RunTutorialCustomVideo();

    // Register play button handler for editor video blocks (lesson_type 3)
    const videoSectionEvents = new VideoSectionEvents();
    videoSectionEvents.handleThumbnailPlay();

    flashcardFlip();
    new EditorQuizzesChecking().getInstance();

    document.addEventListener('publicArticleRendered', () => {
        new AnimationOnScroll('.editor-article-view');
    });

    // The redesigned description card owns its own editor and its own Save; the legacy one still serves
    // every other host of `.editable-course-description`.
    if (document.querySelector('.js-sidebar-description')) {
        new SidebarDescriptionEditor();
    } else {
        new CustomCourseDescription();
    }

    // Course outline: the module rows are the accordion.
    new TableAccordion();
});
